module.exports = __webpack_public_path__ + "static/media/GothamHTF-Bold.d081d923.otf";